// ANCHOR React
import React from 'react';

// ANCHOR Img
import { Img } from '@lyon/components/image';

// ANCHOR Base
import { styled } from 'baseui';
import { AspectRatioBox, AspectRatioBoxBody } from 'baseui/aspect-ratio-box';

// ANCHOR Models
import { CourseCardData } from '@lyon/scoped-models/CourseCardData';

// ANCHOR Utils
import { ucarecdnScaleCropOptimize, ucarecdn } from '@lyon/utils/ucarecdn';

// ANCHOR Components
import { constant } from '@lyon/components/utils/constant';
import { ImageBadgeContainer } from '@lyon/components/utils/ImageBadge/ImageBadgeContainer';
import { LyonCourseCardPurchased } from './LyonCourseCardPurchased';
import { LyonCourseCardPublished } from './LyonCourseCardPublished';
import { LyonCourseCardStatus } from './LyonCourseCardStatus';
import { LyonCourseCardPinned } from './LyonCourseCardPinned';

// ANCHOR Styles
import { POSTER } from './styles';

const Poster = styled('div', POSTER);

export const LyonCourseCardHeader = constant(() => {
  const [src, alt, fromProvider] = CourseCardData.useSelectors((state) => [
    state.data?.courseDisplayPhotoUuid,
    state.data?.title,
    state.fromProvider,
  ]);

  const actualSrc = src?.split('/')[0];

  return (
    <AspectRatioBox aspectRatio={16 / 9}>
      <AspectRatioBoxBody>
        <Poster>
          <Img
            src={actualSrc ? ucarecdnScaleCropOptimize('1200x675', actualSrc) : ucarecdn('2dac1789-410f-4099-b016-1cfd1efa67c9/-/crop/1200x675/0,0')}
            alt={alt ?? ''}
          />
        </Poster>
        <ImageBadgeContainer>
          {
            fromProvider
              ? <LyonCourseCardPublished />
              : (
                <>
                  <LyonCourseCardPurchased />
                  <LyonCourseCardStatus />
                </>
              )
          }
          <LyonCourseCardPinned />
        </ImageBadgeContainer>
      </AspectRatioBoxBody>
    </AspectRatioBox>
  );
});
